import { render, staticRenderFns } from "./SuppliersStockSoldItems.vue?vue&type=template&id=8220c3d0&"
import script from "./SuppliersStockSoldItems.vue?vue&type=script&lang=js&"
export * from "./SuppliersStockSoldItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports